<template>
  <div class="handle-wrap">
    <p :class="permsBool ? 'color-success' : 'color-dis'" @click="toEdit">
      编辑
    </p>
    <p :class="permsBool ? 'color-success' : 'color-dis'" @click="switchStatus">
      {{ statuText }}
    </p>
    <p
      :class="permsBool && data.status === 1 ? 'color-success' : 'color-dis'"
      @click="del"
      v-if="data.status !== 2"
    >
      删除
    </p>
  </div>
</template>

<script>
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { dingtalkApi } from "../../../assets/js/http-serve/dingtalkApi";
import { gantConf, getPermInfo } from "../../../assets/js/utils/jurisdiction";
import { mapGetters } from "vuex";
import { callbackLog } from "@/assets/js/utils/publicMethods";

export default {
  name: "FlowHandles",
  props: {
    data: {}
  },
  computed: {
    ...mapGetters(["currentAuthUser"]),
    perms () {
      return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
    },
    statuText () {
      if (this.data.status === 0) {
        return "停用";
      } else if (this.data.status === 1) {
        return "启用";
      }
    },
    permsBool () {
      const perms = this.perms;
      return perms.includes(gantConf.documentApproval);
    }
  },
  methods: {
    /** 权限验证 */
    permsEven (pid = gantConf.documentApproval) {
      const perms = this.perms;
      const bool = perms.includes(pid);
      if (!bool) {
        const Pinfo = getPermInfo(pid)
        this.$message.error(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`)
      }
      return bool
    },
    /**
     * 前往编辑
     */
    toEdit () {
      const bool = this.permsEven()
      if (!bool) return
      this.$router.push({
        path: "/console/dingComponents/approval",
        query: this.data
      });
    },
    /**
     * 启用、停用
     */
    async switchStatus () {
      const bool = this.permsEven()
      if (!bool) return
      const { dingTalkCorpId, dingTalkUserId } = JSON.parse(
        sessionStorage.getItem("dingloginInfo")
      );
      let param = {
        flowId: this.data.flowId,
        status: this.data.status === 0 ? 1 : 0,
        corpId: dingTalkCorpId,
        dingTalkUserId
      };
      let res = await dingtalkApi.updateStatus(param);
      if (res.success) {
        const {flowId,flowName,status}=this.data
            callbackLog({
          module:6,
          desc:`${status !== 1 ? '停用' : '启用'}审批流程：${flowName}(ID：${flowId})`
          })
        this.$message.success(res.description || "操作成功");
        // 直接修改状态，不需要调用分页查询接口
        this.data.status = param.status;
      } else {
        this.$message.error(res.description || "操作失败，请重试");
      }
    },
    /**
     * 删除
     */
    del () {
      // 当状态不为停用状态不执行删除
      if(this.data.status !== 1) return false
      const bool = this.permsEven()
      if (!bool) return
      this.$confirm("是否删除审批流程", "系统提示")
        .then(async () => {
          // 删除接口
          const { dingTalkCorpId, dingTalkUserId } = JSON.parse(
            sessionStorage.getItem("dingloginInfo")
          );
          let param = {
            flowId: this.data.flowId,
            status: 2,
            corpId: dingTalkCorpId,
            dingTalkUserId
          };
          let res = await dingtalkApi.updateStatus(param);
          if (res.success) {
            const {flowId,flowName,flowType}=this.data
            callbackLog({
          module:6,
          desc:`删除审批流程：${flowName}(ID：${flowId})`
          })
            this.$message.success(res.description || "删除审批流程成功");
            this.$emit("reloadList");
          } else {
            this.$message.error(res.description || "操作失败");
            this.$emit("reloadList");
          }
        })
        .catch(() => { });
    }
  },
};
</script>

<style lang="less" scoped>
.handle-wrap {
  > p {
    font-size: 14px;
    cursor: pointer;
    color: #290202;
    font-weight: bold;
  }

  .color-success:hover {
    color: #ec1c1c;
  }
  .color-dis {
    color: #ccc;
    cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// pages/console/dingComponents/FlowHandles.vue